import type { AbstractControl, ValidatorFn } from '@angular/forms';
import type { CountryCode } from 'libphonenumber-js';
import { parsePhoneNumber } from 'libphonenumber-js/max';
import type { PhoneNumber } from 'libphonenumber-js/types';
import { getCountryCodeFromPhoneNumber } from '../../country-utils';

// NOTE: validating phone numbers is using 'parsePhoneNumber' function from 'libphonenumber-js/max', so
// max metadata is used, which is more precise and in sync to the backend

export function phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (!control.value) {
            // let the required validator kick-in, if defined
            return null;
        }

        if (control.value.value || control.value.code) {
            const value = control.value.value;
            const countryCode = control.value.code.toUpperCase();

            return !value || isValid(value, countryCode)
                ? null
                : { phoneNumber: { value } };
        }
        const value = control.value;
        const countryCode = getCountryCodeFromPhoneNumber(
            value,
        ).toUpperCase() as CountryCode;

        return isValid(value, countryCode) ? null : { phoneNumber: { value } };
    };
}

function isValid(value: string, countryCode: CountryCode) {
    let parsedPhoneNumber: PhoneNumber;
    try {
        parsedPhoneNumber = parsePhoneNumber(value, countryCode);
    } catch (e) {
        return false;
    }

    return parsedPhoneNumber.isValid();
}
